import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);

  const services = [
    { name: 'Emergency Work', slug: 'emergency-work' },
    { name: 'Ceiling Fans', slug: 'ceiling-fans' },
    { name: 'Power Points', slug: 'power-points' },
    { name: 'Fault Detection', slug: 'fault-detection' },
    { name: 'Smoke Alarms', slug: 'smoke-alarms' },
    { name: 'Lighting Solutions', slug: 'lighting' },
    { name: 'Electrical Repairs', slug: 'electrical-repairs' },
    { name: 'Wiring & Rewiring', slug: 'wiring-rewiring' },
    { name: 'Surge Protection', slug: 'surge-protection' },
    { name: 'Switchboards', slug: 'switchboards' },
    { name: 'Electrical Maintenance', slug: 'electrical-maintenance' },
    { name: 'Solar Batteries', slug: 'solar-batteries' },
  ];

  return (
    <>
      {/* Fixed wrapper for both bars */}
      <div className="fixed top-0 left-0 right-0 z-50">
        {/* Top Utility Bar */}
        <div className="bg-[#f67f19] text-white py-2 px-4">
          <div className="max-w-7xl mx-auto flex justify-between items-center text-xs md:text-sm">
            <div className="flex items-center gap-1 md:gap-2">
              <i className="ri-phone-fill text-sm"></i>
              <a href="tel:0416497716" className="font-semibold hover:underline cursor-pointer whitespace-nowrap">
                0416 497 716
              </a>
            </div>
            <div className="hidden md:flex items-center gap-2 font-bold">
              <i className="ri-price-tag-3-fill"></i>
              <span>$50 OFF ONLINE DISCOUNT</span>
            </div>
            <div className="flex items-center gap-1 md:gap-2">
              <i className="ri-time-line text-sm"></i>
              <span className="font-semibold whitespace-nowrap">Same Day Service</span>
            </div>
          </div>
        </div>

        {/* Main Navigation */}
        <nav className="bg-white shadow-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-14 md:h-20">
              {/* Logo */}
              <Link to="/" className="flex items-center">
                <img
                  src="https://static.readdy.ai/image/1e14a9881218f497bbf78ac6a19724bb/ff4ec48df95ab1022488835e6aca3751.png"
                  alt="Urban Connect Logo"
                  className="h-9 md:h-14 w-auto"
                />
              </Link>

              {/* Center Navigation Links */}
              <div className="hidden lg:flex items-center space-x-8">
                <Link
                  to="/"
                  className="text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer text-[#535669] hover:text-[#f67f19]"
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className="text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer text-[#535669] hover:text-[#f67f19]"
                >
                  About
                </Link>
                <div
                  className="relative"
                  onMouseEnter={() => setIsServicesDropdownOpen(true)}
                  onMouseLeave={() => setIsServicesDropdownOpen(false)}
                >
                  <Link
                    to="/services"
                    className="text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer text-[#535669] hover:text-[#f67f19] flex items-center gap-1"
                  >
                    Services
                    <i className={`ri-arrow-down-s-line transition-transform ${isServicesDropdownOpen ? 'rotate-180' : ''}`}></i>
                  </Link>
                  {isServicesDropdownOpen && (
                    <div className="absolute top-full left-0 pt-1 w-64 z-50">
                      <div className="bg-white shadow-xl rounded-lg border border-gray-100 py-2">
                        {services.map((service) => (
                          <Link
                            key={service.slug}
                            to={`/services/${service.slug}`}
                            className="block px-4 py-2 text-sm text-[#535669] hover:bg-[#f67f19]/5 hover:text-[#f67f19] transition-colors cursor-pointer"
                          >
                            {service.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <Link
                  to="/contact"
                  className="text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer text-[#535669] hover:text-[#f67f19]"
                >
                  Contact
                </Link>
              </div>

              {/* Call Now + Free Quote Buttons */}
              <div className="hidden lg:flex items-center gap-3">
                <Link
                  to="/contact"
                  className="bg-[#535669] text-white px-5 py-3 rounded-full font-bold hover:bg-[#444557] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg"
                >
                  <i className="ri-file-list-3-line text-lg"></i>
                  Free Quote
                </Link>
                <a
                  href="tel:0416497716"
                  className="bg-[#f67f19] text-white px-5 py-3 rounded-full font-bold hover:bg-[#e06e0a] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg"
                >
                  <i className="ri-phone-fill text-lg"></i>
                  0416 497 716
                </a>
              </div>

              {/* Mobile: Call button + Hamburger */}
              <div className="lg:hidden flex items-center gap-2">
                <a
                  href="tel:0416497716"
                  className="bg-[#f67f19] text-white px-3 py-2 rounded-full font-bold text-xs hover:bg-[#e06e0a] transition-all whitespace-nowrap cursor-pointer flex items-center gap-1 shadow"
                >
                  <i className="ri-phone-fill text-sm"></i>
                  Call Now
                </a>
                <button
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  className="cursor-pointer p-1"
                >
                  <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#535669]`}></i>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden bg-white shadow-lg border-t max-h-[70vh] overflow-y-auto">
              <div className="px-4 py-4 space-y-2">
                <Link
                  to="/"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-left text-[#535669] hover:text-[#f67f19] font-semibold cursor-pointer py-2 border-b border-gray-100"
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-left text-[#535669] hover:text-[#f67f19] font-semibold cursor-pointer py-2 border-b border-gray-100"
                >
                  About
                </Link>

                {/* Services Accordion */}
                <div className="border-b border-gray-100">
                  <button
                    onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)}
                    className="flex items-center justify-between w-full text-left text-[#535669] hover:text-[#f67f19] font-semibold cursor-pointer py-2"
                  >
                    <span>Services</span>
                    <i className={`ri-arrow-down-s-line transition-transform ${isMobileServicesOpen ? 'rotate-180' : ''}`}></i>
                  </button>
                  {isMobileServicesOpen && (
                    <div className="pl-4 space-y-1 mb-2">
                      {services.map((service) => (
                        <Link
                          key={service.slug}
                          to={`/services/${service.slug}`}
                          onClick={() => setIsMobileMenuOpen(false)}
                          className="block text-sm text-[#535669] hover:text-[#f67f19] cursor-pointer py-1.5"
                        >
                          {service.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>

                <Link
                  to="/contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-left text-[#535669] hover:text-[#f67f19] font-semibold cursor-pointer py-2 border-b border-gray-100"
                >
                  Contact
                </Link>
                <Link
                  to="/contact"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full bg-[#535669] text-white px-6 py-3 rounded-full font-bold hover:bg-[#444557] transition-colors text-center whitespace-nowrap cursor-pointer mt-2"
                >
                  <i className="ri-file-list-3-line mr-2"></i>
                  Free Quote
                </Link>
              </div>
            </div>
          )}
        </nav>
      </div>
    </>
  );
}